const sliceName = 'board';

export { sliceName };
